import { useTranslation } from "react-i18next";

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    { icon: "ri-search-eye-line", title: t("step1Title"), text: t("step1Text") },
    { icon: "ri-line-chart-line", title: t("step2Title"), text: t("step2Text") },
    { icon: "ri-shield-check-line", title: t("step3Title"), text: t("step3Text") },
    { icon: "ri-checkbox-circle-line", title: t("step4Title"), text: t("step4Text") },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-wider text-accent-600">
            {t("howEyebrow")}
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t("howTitle")}
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <div key={s.title} className="relative p-5 rounded-lg border border-background-200 bg-background-50">
              <span className="absolute top-4 right-4 font-heading text-4xl font-bold text-background-200 select-none">
                {i + 1}
              </span>
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${s.icon} text-lg`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}